import { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { Badge, BadgeType } from "@components/new/Badge";

const statusTypes: Record<string, BadgeType> = {
  Created: BadgeType.PRIMARY,
  Registered: BadgeType.PRIMARY,
  InProcess: BadgeType.PRIMARY,
  Completed: BadgeType.PRIMARY,
  Canceled: BadgeType.DESTRUCTIVE,
};

const PickUpStatusBadge = ({ value }: { value?: string }): ReactElement => {
  const { t } = useTranslation();

  return (
    <Badge type={statusTypes[value ?? ""] ?? BadgeType.SECONDARY}>
      {t(`fbpPage.pickUpOrderStatuses.${value}`)}
    </Badge>
  );
};

export default PickUpStatusBadge;
